import { render } from "./JobList.vue?vue&type=template&id=3ba5c871"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__